import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "show-device-position-modal-component" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Posição correta do dispositivo")
], -1)
const _hoisted_3 = { class: "img-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-content upperSpace" }, " Se após um minuto da colocação do dispositivo de teste acima do suporte não aparecer um fluxo na cor rosa, verifique a posição. Caso necessário empurre o dispositivo como indicado na figura acima. ", -1)
const _hoisted_7 = { class: "action-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_modal, {
      class: "custom-modal",
      ref: "base-modal"
    }, {
      content: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", { src: _ctx.positionCorrectImage }, null, 8, _hoisted_4),
          _createElementVNode("img", { src: _ctx.positionWrongImage }, null, 8, _hoisted_5)
        ]),
        _hoisted_6
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack())),
            class: "btn btn-default btn-primary upperSpace buttonLarge"
          }, " Entendi ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}